import * as React from "react"
import { createContext, useState, useEffect, useRef } from "react"
import styled from "styled-components"

import "../../styles/reset.css"
import "../../styles/global.css"
import { getRouteName } from "../../utils/get-route-name.util"
import Footer from "../footer/footer"
import { Header } from "../header/header"
import { SPOnlyFlex } from "../../styles/base-styles"
import { ScrolltopNav } from "../common/scroll-top-nav"

export const BlockedScrollContext = createContext<{
  isBlocked: boolean
  setIsBlocked: React.Dispatch<React.SetStateAction<boolean>>
} | null>(null)

interface LayoutProps extends React.PropsWithChildren {
  isTopPage?: boolean
}

export const Layout: React.FC<LayoutProps> = ({ children, isTopPage = false }) => {
  const [isBlocked, setIsBlocked] = useState(false)
  const [routeName, setRouteName] = useState<undefined | string>(undefined)
  const scrollElementRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const route = getRouteName()
    if (!route) {
      return
    }

    setRouteName(route)

    const savedOffset = localStorage.getItem(route)
    const previousRoute = localStorage.getItem("previousRoute")

    setTimeout(() => {
      localStorage.setItem("previousRoute", route)
    }, 100)

    if (previousRoute === route && savedOffset) {
      setTimeout(() => {
        if (scrollElementRef.current) {
          scrollElementRef.current.scrollTop = Number(savedOffset)
        }
      }, 50)
    }
  }, [])

  return (
    <BlockedScrollContext.Provider value={{ isBlocked, setIsBlocked }}>
      <ScrollBlockableDiv
        ref={scrollElementRef}
        onScroll={e => {
          if (routeName) {
            localStorage.setItem(routeName, String(e.currentTarget.scrollTop))
          }
        }}
      >
        <Header isTopPage={isTopPage} />
        <main style={{ background: "#fff" }}>{children}</main>
        <ScrolltopNavContainer>
          <ScrolltopNav />
        </ScrolltopNavContainer>
        <Footer />
      </ScrollBlockableDiv>
    </BlockedScrollContext.Provider>
  )
}

const ScrollBlockableDiv = styled.div`
  scroll-behavior: smooth;
`

const ScrolltopNavContainer = styled(SPOnlyFlex)`
  justify-content: flex-end;
  margin: 28px;
`
